import { createGlobalStyle, css } from "styled-components";
import { styleTransformHelper as t } from "helpers";

const style = createGlobalStyle(
  ({
    theme: {
      isMobile,
      constant: {
        screens: { xl },
      },
      utils: { flex },
      color: {
        hue246Surface,
        infoText,
        neutralsBorderDisabled,
        neutralsSurface,
        neutralsSurfaceHover,
        warningSurface,
        warningText,
        neutralsTextTertiary,
        neutralsShapeSecondary,
      },
      selectedTheme,
    },
  }: any) =>
    t(css`
      /* custom fonts */

      @font-face {
        font-family: "Inter";
        src: url("/assets/fonts/Inter-Regular.ttf") format("truetype");
        font-style: normal;
        font-weight: 400;
        font-display: swap;
      }

      @font-face {
        font-family: "InterBold";
        src: url("/assets/fonts/Inter-Bold.ttf") format("truetype");
        font-style: normal;
        font-weight: 400;
        font-display: swap;
      }

      /* custom font end */

      *,
      pre {
        font-family: Inter, "Open sans";
      }

      :root {
        color-scheme: ${selectedTheme === "dark" ? "dark" : "light"};
      }

      html {
        font-size: ${isMobile ? "14px" : "16px"};
      }
      svg {
        width: 15px;
        margin: auto;
        display: flex;
      }
      p,
      h1,
      h2,
      h3 {
        margin-bottom: 0;
      }
      button {
        background-color: transparent;
        border: none;
        cursor: pointer;
      }
      &.link {
        border: none;
        box-shadow: none;
        background: none;
      }
      .emptyItem {
        ${flex("center", "center", "row")};
        padding: 6px 0;
        background: ${neutralsSurface};
        color: ${neutralsShapeSecondary};

        border: 1px dashed ${hue246Surface};
        border-radius: 4px;
        margin: 10px;
        svg {
          margin: 5px;
          width: 10px;
        }
      }
      .sb-show-main.sb-main-padded {
        overflow-x: hidden !important;
        padding: 0 !important;
      }
      .ant-drawer-content {
        border-radius: 16px 0px 0px 16px;
        box-shadow: 0px 2px 4px rgb(190 191 191 / 16%),
          0px 8px 16px 4px rgb(229 231 237 / 24%);
      }
      .ant-dropdown-menu {
        padding: 0;
        border-radius: 4px;
        .ant-dropdown-menu-item {
          display: flex;
          flex-direction: row-reverse;
          padding: 8px 15px;
          font-size: 14px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          svg {
            width: 13px;
          }
          &:hover {
            background-color: ${neutralsSurfaceHover};
          }
        }
      }
      // Modal

      .ant-modal-title {
        display: flex;
        svg {
          margin-right: 14px;
          width: 20px;
          height: 20px;
        }
      }
      .profile-select-modal {
        .ant-modal-body {
          padding: 0 1.5rem 1rem 1.5rem !important;
        }
        .ant-modal {
          max-width: 360px;
        }
        .ant-modal-title {
          align-items: center;
          svg {
            width: 30px;
            height: 30px;
          }
        }
      }
      .avatar-select-modal {
        .ant-modal-body {
          padding: 0 1rem 1rem 1rem !important;
        }
        .ant-modal {
          width: 630px !important;
        }
        .ant-modal-title {
          align-items: center;
          svg {
            width: 30px;
            height: 30px;
          }
        }
        .icon-selectAvatarIcon path {
          fill: ${neutralsTextTertiary};
        }
      }
      .ant-modal-close-x {
        width: 28px;
        height: 28px;
        margin: 16px;
        .background-circle {
          background: ${neutralsSurface};
          border-radius: 100px;

          svg {
            width: 28px;
            height: 28px;
            g {
              width: 12px;
              height: 12px;
            }
          }
        }
      }
      .title-header .ant-modal-body {
        padding-top: 0 !important;
      }
      .ant-modal-body {
        padding: 22px 16px 16px 16px;
      }
      .ant-modal-header {
        border-bottom: none !important;
        padding: 16px 22px !important;
      }
      // Tag
      .ant-tag-volcano {
        background: ${warningSurface};
        color: ${warningText};
        font-weight: 600;
        border: none;
      }
      // Scroll
      &::-webkit-scrollbar {
        width: 6px;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background: ${neutralsBorderDisabled};
        border-radius: 16px;
        background-clip: padding-box;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: ${neutralsBorderDisabled};
      }
      //
      .reminder-modal {
        .ant-modal {
          width: 50% !important;
          @media (max-width: ${xl}) {
            width: 90% !important;
          }
        }
      }

      .ant-picker-today-btn {
        color: ${infoText} !important;
      }
      .ant-picker-cell-in-view.ant-picker-cell-selected {
        color: unset !important;
        border: 1px solid;
        border-radius: 50%;
      }
    `)
);

export default style;
